/* eslint no-unused-vars: "error"*/
import React, { useEffect, useState } from 'react';
import DataFilter from '@components/Graphs/MultiStation/DataFilter';
import GraphRenderer from '@components/Graphs/MultiStation/Renderer';

import {
  MultiStationContextProvider,
  useMultiStationContext,
} from '@components/Graphs/MultiStation/MultiStationContext';
import WeatherForecast from '@awp/components/WeatherForecast/WeatherForecast';
import { AwpContainer } from '@components/Common/AwpContainer';

const MultiStationGraph = () => {
  return (
    <AwpContainer fluid={true}>
      <MultiStationContextProvider isForGraph={true}>
        <GraphRendererWrapper />
      </MultiStationContextProvider>
    </AwpContainer>
  );
};

const GraphRendererWrapper = () => {
  const { weatherStations, weatherStationId, presetId, setForecastWeatherStationId, hasDeferWeatherStation } =
    useMultiStationContext();

  const [selectedWeatherStation, setSelectedWeatherStation] = useState(null);
  const [weatherStationIndex, setWeatherStationIndex] = useState(0);

  useEffect(() => {
    //when the preset changes, we need to reset the selected station and index
    setSelectedWeatherStation(null);
    setForecastWeatherStationId(null);
    if (hasDeferWeatherStation && weatherStationId > 0 && weatherStations.length > 0) {
      setWeatherStationIndex(weatherStations.findIndex((station) => station.Id === weatherStationId));
    } else {
      setWeatherStationIndex(0);
    }
  }, [presetId]);

  useEffect(() => {
    setSelectedWeatherStation(weatherStations[weatherStationIndex]);
    setForecastWeatherStationId(weatherStations[weatherStationIndex]?.Id);
  }, [weatherStations, weatherStationIndex]);

  useEffect(() => {
    if (!weatherStationId || weatherStationId === -1 || !weatherStations) return;
    if (weatherStationId > 0 && weatherStations.length > 0) {
      setWeatherStationIndex(weatherStations.findIndex((station) => station.Id === weatherStationId));
    }
  }, [weatherStationId]);

  const moveWXForward = () => {
    let wxIdx = weatherStationIndex;
    wxIdx = wxIdx + 1;
    if (wxIdx > weatherStations.length - 1) {
      wxIdx = 0;
    }
    if (!hasDeferWeatherStation && weatherStationId > 0) {
      const defWxIdx = prevDeferredStationIndex();
      if (wxIdx !== defWxIdx) {
        setWeatherStationIndex(wxIdx);
      } else {
        wxIdx = wxIdx + 1;
        if (wxIdx > weatherStations.length - 1) {
          wxIdx = 0;
        }
        setWeatherStationIndex(wxIdx);
      }
    } else {
      setWeatherStationIndex(wxIdx);
    }
  };
  const prevDeferredStationIndex = () => {
    //current is non-deferred but previous deferred station was selected
    // find the previous defered station index
    if (!hasDeferWeatherStation && weatherStationId > 0) {
      return weatherStations?.findIndex((ws) => ws.Id === weatherStationId);
    }
    return -1;
  };
  const moveWXBackward = () => {
    let wxIdx = weatherStationIndex;
    wxIdx = wxIdx - 1;
    if (wxIdx < 0) {
      wxIdx = weatherStations?.length - 1;
    }
    if (!hasDeferWeatherStation && weatherStationId > 0) {
      const defWxIdx = prevDeferredStationIndex();
      if (wxIdx !== defWxIdx) {
        setWeatherStationIndex(wxIdx);
      } else {
        wxIdx = wxIdx - 1;
        if (wxIdx < 0) {
          wxIdx = weatherStations?.length - 1;
        }
        setWeatherStationIndex(wxIdx);
      }
    } else {
      setWeatherStationIndex(wxIdx);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <DataFilter />
      {selectedWeatherStation && presetId > 0 && (
        <WeatherForecast
          weatherStation={selectedWeatherStation}
          stationSelections={{ moveWXBackward, moveWXForward }}
          isMultiStation={true}
        />
      )}
      <GraphRenderer />
    </div>
  );
};

export default MultiStationGraph;
